/**
 * Module definition for globalreports module. The globalreports module manages
 * the application's top-level globalreports view (i.e., /global-reports).
 *
 * @module routes.globalreports
 */

angular.module('routes.globalreports', [
  'stack',
  'routes.globalreports.constants',
  'routes.globalreports.GlobalReportsController',
  'routes.globalreports.GlobalReportsPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.globalreports', {
          url: '/global-reports',
          templateUrl: 'routes/globalreports/globalreports.html',
          controller: 'GlobalReportsController',
          params: {
            reportId: { value: null, squash: true }
          },
          resolve: {
            constants: [
              'ConstantResolver',
              'GLOBALREPORTS',
              function (ConstantResolver, GLOBALREPORTS) {
                return new ConstantResolver(GLOBALREPORTS);
              }
            ],
            reportsPayload: [
              'GlobalReportsPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (GlobalReportsPayloadResolver, $stateParams, newmanPayload) {
                return new GlobalReportsPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
